import React from 'react'
import ControlledModal from '../../../../components/modals/ControlledModal'
import ModalHeader from './sections/ModalHeaderSection.js'
import AddSegwareTechnicianForm from './Form/AddSegwareTechnicianForm.js'

const AddSegwareTechnicianModal = props => {
  return (
    <ControlledModal width="62rem" {...props}>
      <ModalHeader />
      <AddSegwareTechnicianForm />
    </ControlledModal>
  )
}

export default AddSegwareTechnicianModal
